import styled, { css } from 'styled-components'

export const Container = styled.div`
    max-height: 500px;
    max-width: 400px;
    width: 100%;
    background: #FFF;
    border-radius: 5px;
    padding: 33px;
    box-shadow: rgb(0 0 0 / 46%) 0px 5px 10px;

    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 9;

    transform: translateY(100%);

    overflow-y: auto;

    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;
`

export const Country = styled.div`
    border-left: 1px solid #DDD;
    padding-left: 1rem;
    position: relative;

    p{
        font-weight: bold;
    }

    svg{
        cursor: pointer;
        color: #e05f59;
        font-size: 1rem;
    }  

    .countryBullet{
        height: 0.9rem;
        width: 0.9rem;
        border-radius: 50%;
        background: #000;
        position: absolute;
        top: 0;
        left: 0;
        transform: translate(-50%, 80%);
        background: #7A05A7;
    }

    .cleanCountryButton{
        opacity: 0;
        transition: opacity .15s;
    }

    .buttonCountry{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #DDD;
        border-radius: 5px;
        padding: 0.5rem;
        color: #000;

        &:hover {
            .cleanCountryButton{
                opacity: 1;
            }
        }
    }


    ${props => props.isLoading && css`
        pointer-events: none;
        opacity: 0.7;
    `}
`